import clsx from "clsx";

import { MediaItem } from "@/components/common/MediaItem";

import { CtaButton } from "./CtaButton";

import type { AdsLandingTwoUpRow } from "./types";

export function TwoUpRows({ rows }: { rows: AdsLandingTwoUpRow[] }) {
  if (rows.length === 0) {
    return null;
  }

  return (
    <div className="flex w-full flex-col gap-16 pt-16">
      {rows.map((row) => (
        <TwoUpRow key={row.headline} row={row} />
      ))}
    </div>
  );
}

function TwoUpRow({ row }: { row: AdsLandingTwoUpRow }) {
  const mediaFirst = row.mediaAlignment === "left";

  return (
    <div className="grid min-h-[395px] grid-cols-1 items-center gap-6 md:grid-cols-2">
      <div
        className={clsx(
          "flex min-w-0 items-center justify-start md:justify-center",
          mediaFirst ? "md:order-2" : "md:order-1",
        )}
      >
        <TwoUpText row={row} />
      </div>
      <div
        className={clsx(
          "flex min-w-0 items-center justify-center",
          mediaFirst ? "md:order-1" : "md:order-2",
        )}
      >
        {row.media ?
          <TwoUpMedia media={row.media} />
        : null}
      </div>
    </div>
  );
}

function TwoUpText({ row }: { row: AdsLandingTwoUpRow }) {
  return (
    <div className="text-primary flex w-full flex-col items-start gap-5 px-6 md:max-w-[300px] md:px-8">
      <h3 className="text-[24px] leading-[1.32] font-medium text-balance md:text-[30px]">
        {row.headline}
      </h3>
      {row.body ?
        <p className="text-[17px] leading-7">{row.body}</p>
      : null}
      {row.ctas.length > 0 ?
        <div className="flex flex-wrap items-center gap-3">
          {row.ctas.map((cta) => (
            <CtaButton key={`${cta.label}-${cta.href}`} cta={cta} />
          ))}
        </div>
      : null}
    </div>
  );
}

function TwoUpMedia({ media }: { media: NonNullable<AdsLandingTwoUpRow["media"]> }) {
  return <MediaItem {...media} ratio={media.ratio ?? "1/1"} className="w-full md:rounded-[6px]" />;
}
